module.exports = __webpack_public_path__ + "img/car-at-pole@2x.4a5a88a1.png";